import React from "react";

export default function Setting() {
  return (
    <div>
      <p>Setting</p>
    </div>
  );
}
